import { useSelector } from 'react-redux'
import SeriesPresentationList from '../../events/SeriesPresentationList'

import classes from './ProgramDashboardManager.module.scss'
import classnames from 'classnames'

const SeriesScheduleTab = () => {
  const { program } = useSelector((state) => state.programDashboard)

  return (
    <SeriesPresentationList
      series={program.series}
      timezone={program.communityTimezone}
      className={classnames('pb-1', classes.tabPanelContentWidth)}
      isEditable
    />
  )
}

export default SeriesScheduleTab
